(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  /**
   * Wraps a cart section (this drawer, the cart page). Quantity/remove links
   * become /cart/change.js calls that re-render the section (Section Rendering
   * API) and update the header count. Defined here, not in snippets/cart-line:
   * a snippet's script only loads when the snippet renders, and an empty bag
   * renders no lines.
   */
  class CartLines extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.#onClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.#onClick);
    }

    #onClick = (event) => {
      const control = event.target.closest('[data-line]');
      if (!control) return;
      event.preventDefault();
      this.change(Number(control.dataset.line), Number(control.dataset.quantity));
    };

    /**
     * Change a line's quantity. On failure nothing is re-rendered, so the line keeps
     * the quantity it had; the shop's reason is written under the line and announced.
     */
    async change(line, quantity) {
      const focus = this.#focusKey(line);
      for (const error of this.querySelectorAll('[data-line-error]')) error.textContent = '';
      this.setAttribute('aria-busy', 'true');
      try {
        let response;
        let cart;
        try {
          response = await fetch(`${window.Shopify?.routes?.root ?? '/'}cart/change.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ line, quantity, sections: [this.dataset.section], sections_url: window.location.pathname }),
          });
          cart = await response.json();
        } catch {
          throw new Error(CartLines.strings().quantityError);
        }
        if (!response.ok) throw new Error(cart.description || cart.message || CartLines.strings().quantityError);
        CartLines.renderSection(this.dataset.section, cart.sections?.[this.dataset.section]);
        CartLines.updateCount(cart.item_count);
        // the shop may cap the quantity at the stock left instead of refusing it
        const kept = quantity > 0 ? cart.items?.[line - 1]?.quantity : undefined;
        if (kept !== undefined && kept < quantity) {
          this.showError(line, (CartLines.strings().quantityLimited ?? '').replace('[count]', kept));
        }
        this.#restoreFocus(focus);
      } catch (error) {
        this.showError(line, error.message || CartLines.strings().quantityError);
      } finally {
        this.removeAttribute('aria-busy');
      }
    }

    showError(line, message) {
      if (!message) return;
      const slot = this.querySelector(`[data-line-item="${line}"] [data-line-error]`);
      if (slot) slot.textContent = message;
      window.announce?.(message);
    }

    /** Where keyboard focus was (a control in a line), so it can come back after the re-render. */
    #focusKey(line) {
      const active = document.activeElement;
      if (!active || !this.contains(active)) return null;
      return { line, label: active.getAttribute('aria-label') };
    }

    #restoreFocus(key) {
      if (!key) return;
      const item = this.querySelector(`[data-line-item="${key.line}"]`);
      const same = item && [...item.querySelectorAll('a[href], button, [aria-disabled="true"]')].find((el) => el.getAttribute('aria-label') === key.label);
      // the same control, else the line now in that place, else the bag's heading
      const target = same ?? item?.querySelector('.cart-line__title') ?? this.querySelector('#CartDrawerTitle, h1');
      if (target && !target.hasAttribute('tabindex') && !target.matches('a[href], button, input, textarea, select')) {
        target.setAttribute('tabindex', '-1');
      }
      target?.focus();
    }

    static strings() {
      try {
        CartLines.messages ??= JSON.parse(document.querySelector('[data-cart-strings]')?.textContent || '{}');
      } catch {
        CartLines.messages = {};
      }
      return CartLines.messages;
    }

    /**
     * Swap a section's contents with freshly rendered HTML. A section may have several
     * [data-section-root] parts (the cart page does, so the express buttons between them
     * are never re-rendered); they are matched in document order.
     */
    static renderSection(id, html) {
      if (!html) return;
      const selector = `[data-section-root="${id}"]`;
      const fresh = new DOMParser().parseFromString(html, 'text/html').querySelectorAll(selector);
      const current = document.querySelectorAll(selector);
      current.forEach((part, index) => {
        if (fresh[index]) part.innerHTML = fresh[index].innerHTML;
      });
    }

    static updateCount(count) {
      for (const badge of document.querySelectorAll('.site-header__count')) {
        badge.textContent = count;
        badge.hidden = count === 0;
      }
      const label = CartLines.countLabel(count);
      if (!label) return;
      for (const link of document.querySelectorAll('.site-header__cart')) link.setAttribute('aria-label', label);
    }

    /** "Bag, 1 item" from the plural templates the drawer renders (header.cart_count.one/other). */
    static countLabel(count) {
      try {
        CartLines.countStrings ??= JSON.parse(document.querySelector('[data-cart-count-strings]')?.textContent || 'null');
      } catch {
        CartLines.countStrings = null;
      }
      const strings = CartLines.countStrings;
      if (!strings) return null;
      let rule = 'other';
      try {
        rule = new Intl.PluralRules(document.documentElement.lang || undefined).select(count);
      } catch {}
      return (strings[rule] ?? strings.other).replace('[count]', count);
    }
  }

  if (!customElements.get('cart-lines')) customElements.define('cart-lines', CartLines);

  /**
   * The bag drawer. Opens from the header bag icon and after add-to-bag;
   * `add(formData)` is called by product forms.
   */
  class CartDrawer extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.section = this.querySelector('cart-lines')?.dataset.section;
      this.dialog.addEventListener('click', this.#onDialogClick);
      document.addEventListener('click', this.#onDocumentClick);
      // a language/currency switch made from inside the bag reloads the page; show the bag again
      // (snippets/locale-modal sets the note just before it submits)
      let reopen = false;
      try {
        reopen = sessionStorage.getItem('morrow:reopen-bag') === '1';
        sessionStorage.removeItem('morrow:reopen-bag');
      } catch {}
      if (reopen) this.open();
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.#onDocumentClick);
    }

    open() {
      if (!this.dialog.open) this.dialog.showModal();
    }

    close() {
      this.dialog.close();
    }

    /** Add a product form's data to the cart, re-render, open. Throws with the shop's message on failure. */
    async add(formData) {
      formData.append('sections', this.section);
      formData.append('sections_url', window.location.pathname);
      const response = await fetch(`${window.Shopify?.routes?.root ?? '/'}cart/add.js`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData,
      });
      // a failed request may not answer in JSON: show the shop's words when there are some, never a parser error
      const result = await response.json().catch(() => null);
      if (!response.ok || !result) {
        throw new Error(result?.description || result?.message || window.themeStrings?.addError || '');
      }
      CartLines.renderSection(this.section, result.sections?.[this.section]);
      const count = this.querySelector('.cart-drawer__title')?.textContent.match(/\d+/)?.[0];
      if (count) CartLines.updateCount(Number(count));
      this.open();
      window.announce?.(window.themeStrings?.addedToBag ?? 'Added to bag');
    }

    #onDialogClick = (event) => {
      if (event.target === this.dialog || event.target.closest('[data-close]')) this.close();
    };

    #onDocumentClick = (event) => {
      const link = event.target.closest('.site-header__cart');
      if (!link || window.location.pathname.endsWith('/cart')) return;
      event.preventDefault();
      this.open();
    };
  }

  if (!customElements.get('cart-drawer')) customElements.define('cart-drawer', CartDrawer);

  /**
   * Pieces this browser has looked at, newest first: [{ id, handle }]. Written by
   * sections/product; per visitor only (localStorage), so it may be empty or unavailable.
   */
  const RecentlyViewed = {
    key: 'morrow:recent',
    read() {
      try {
        const list = JSON.parse(window.localStorage.getItem(this.key) || '[]');
        return Array.isArray(list) ? list.filter((item) => item && item.handle) : [];
      } catch {
        return [];
      }
    },
    forget(handle) {
      try {
        window.localStorage.setItem(this.key, JSON.stringify(this.read().filter((item) => item.handle !== handle)));
      } catch {}
    },
  };

  const storeRoot = () => window.Shopify?.routes?.root ?? '/';

  /** Fetch a section rendered on a URL (Section Rendering API) and parse it. */
  async function fetchSection(url) {
    const response = await fetch(url);
    if (!response.ok) return null;
    return new DOMParser().parseFromString(await response.text(), 'text/html');
  }

  /** Run `load` once, the first time the element is actually on screen (panel shown, drawer open). */
  function whenVisible(element, load) {
    const observer = new IntersectionObserver((entries) => {
      if (!entries.some((entry) => entry.isIntersecting)) return;
      observer.disconnect();
      load();
    });
    observer.observe(element);
    return observer;
  }

  /** "Bag / Recently viewed" tabs (WAI-ARIA tabs: click, arrow keys, Home / End). */
  class CartTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = [...this.querySelectorAll('[role="tab"]')];
      this.addEventListener('click', this.#onClick);
      this.addEventListener('keydown', this.#onKeydown);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.#onClick);
      this.removeEventListener('keydown', this.#onKeydown);
    }

    select(tab, focus = false) {
      for (const each of this.tabs) {
        const selected = each === tab;
        each.setAttribute('aria-selected', String(selected));
        each.tabIndex = selected ? 0 : -1;
        // by id in the document: on the cart page the panels sit outside <cart-tabs>
        const panel = document.getElementById(each.getAttribute('aria-controls'));
        if (panel) panel.hidden = !selected;
      }
      if (focus) tab.focus();
    }

    #onClick = (event) => {
      const tab = event.target.closest('[role="tab"]');
      if (tab && this.tabs.includes(tab)) this.select(tab);
    };

    #onKeydown = (event) => {
      const index = this.tabs.indexOf(event.target);
      if (index === -1) return;
      const last = this.tabs.length - 1;
      const next = { ArrowRight: index + 1, ArrowLeft: index - 1, Home: 0, End: last }[event.key];
      if (next === undefined) return;
      event.preventDefault();
      this.select(this.tabs[(next + this.tabs.length) % this.tabs.length], true);
    };
  }

  if (!customElements.get('cart-tabs')) customElements.define('cart-tabs', CartTabs);

  /**
   * Suggestions under an empty bag, from sections/cart-suggestions: Shopify's
   * recommendations for the last piece viewed, else the store's best sellers.
   */
  class CartSuggestions extends HTMLElement {
    connectedCallback() {
      // this block stays hidden until it has cards, and a hidden element never intersects:
      // watch the empty-bag area around it instead
      this.observer = whenVisible(this.parentElement ?? this, () => this.load());
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    async load() {
      const list = this.querySelector('[data-suggestions]');
      const last = RecentlyViewed.read().find((item) => item.id);
      const sources = [];
      if (last) sources.push(`${storeRoot()}recommendations/products?product_id=${encodeURIComponent(last.id)}&limit=4&intent=related&section_id=cart-suggestions`);
      sources.push(`${storeRoot()}collections/all?sort_by=best-selling&section_id=cart-suggestions`);
      // recommendations first, topped up with best sellers until there are four different pieces
      const picked = new Map();
      for (const url of sources) {
        if (picked.size >= 4) break;
        try {
          const html = await fetchSection(url);
          for (const item of html?.querySelectorAll('.cart-suggestions__source > li') ?? []) {
            const href = item.querySelector('a[href]')?.getAttribute('href')?.split('?')[0];
            if (!href || picked.has(href) || picked.size >= 4) continue;
            picked.set(href, document.importNode(item, true));
          }
        } catch {
          // suggestions are a nicety: an empty bag still reads fine without them
        }
      }
      if (!picked.size) return;
      list.replaceChildren(...picked.values());
      this.hidden = false;
    }
  }

  if (!customElements.get('cart-suggestions')) customElements.define('cart-suggestions', CartSuggestions);

  /**
   * "Pairs well with" under a filled bag: up to two pieces not already in it, from
   * Shopify's complementary recommendations for the piece added last, topped up from
   * related recommendations, then best sellers (sections/cart-suggestions, compact rows).
   * Responses are kept for the page's life: the drawer re-renders on every change.
   */
  class CartCrossSell extends HTMLElement {
    static limit = 2;
    static responses = new Map();

    connectedCallback() {
      this.addEventListener('click', this.#onClick);
      // hidden until filled, and below the lines inside a scroll box: load once the bag is on screen
      this.observer = whenVisible(this.closest('.cart-drawer__scroll') ?? this.parentElement ?? this, () => this.load());
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.#onClick);
      this.observer?.disconnect();
    }

    static fetch(url) {
      if (!CartCrossSell.responses.has(url)) CartCrossSell.responses.set(url, fetchSection(url).catch(() => null));
      return CartCrossSell.responses.get(url);
    }

    async load() {
      const id = encodeURIComponent(this.dataset.productId || '');
      const exclude = new Set((this.dataset.exclude || '').split(',').filter(Boolean));
      const recommend = (intent) =>
        `${storeRoot()}recommendations/products?product_id=${id}&limit=6&intent=${intent}&section_id=cart-suggestions`;
      const sources = [
        ...(id ? [recommend('complementary'), recommend('related')] : []),
        `${storeRoot()}collections/all?sort_by=best-selling&section_id=cart-suggestions`,
      ];
      const picked = new Map();
      for (const url of sources) {
        if (picked.size >= CartCrossSell.limit) break;
        const html = await CartCrossSell.fetch(url);
        for (const item of html?.querySelectorAll('.cart-suggestions__compact > li') ?? []) {
          const product = item.dataset.productId;
          if (!product || exclude.has(product) || picked.has(product) || picked.size >= CartCrossSell.limit) continue;
          picked.set(product, document.importNode(item, true));
        }
      }
      if (!picked.size || !this.isConnected) return;
      this.querySelector('[data-cross-sell]').replaceChildren(...picked.values());
      this.hidden = false;
    }

    #onClick = async (event) => {
      const button = event.target.closest('[data-cross-add]');
      if (!button) return;
      const drawer = this.closest('cart-drawer');
      if (!drawer) return;
      const formData = new FormData();
      formData.append('id', button.dataset.variantId);
      formData.append('quantity', '1');
      button.disabled = true;
      try {
        await drawer.add(formData);
        // the row is gone with the re-render: land on the bag's heading ("Bag (n)")
        drawer.querySelector('#CartDrawerTitle')?.focus();
      } catch (error) {
        button.disabled = false;
        window.announce?.(error.message || CartLines.strings().quantityError);
      }
    };
  }

  if (!customElements.get('cart-cross-sell')) customElements.define('cart-cross-sell', CartCrossSell);

  /** "Recently viewed": each remembered piece rendered by sections/product-card-fragment. */
  class RecentProducts extends HTMLElement {
    static limit = 8;

    connectedCallback() {
      this.observer = whenVisible(this, () => this.load());
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    async load() {
      const list = this.querySelector('[data-recent]');
      const empty = this.querySelector('[data-recent-empty]');
      const here = document.querySelector('product-page')?.dataset.handle;
      const handles = RecentlyViewed.read()
        .map((item) => item.handle)
        .filter((handle) => handle !== here)
        .slice(0, RecentProducts.limit);
      const cards = await Promise.all(
        handles.map(async (handle) => {
          try {
            const html = await fetchSection(`${storeRoot()}products/${encodeURIComponent(handle)}?section_id=product-card-fragment`);
            const card = html?.querySelector('.card-fragment .product-card');
            if (!card) {
              RecentlyViewed.forget(handle);
              return null;
            }
            const item = document.createElement('li');
            item.append(document.importNode(card, true));
            return item;
          } catch {
            return null;
          }
        }),
      );
      const found = cards.filter(Boolean);
      list.replaceChildren(...found);
      empty.hidden = found.length > 0;
    }
  }

  if (!customElements.get('recent-products')) customElements.define('recent-products', RecentProducts);

  /* ---------- snippets/cart-shipping-progress (defined here: a snippet's script only loads when it renders at page load) ---------- */

  /**
   * Only does work when the bag is in a currency other than the shop's (data-convert):
   * converts the threshold at Shopify's rate and rewrites the text, bar and shipping row.
   */
  class CartShippingProgress extends HTMLElement {
    connectedCallback() {
      if (!this.hasAttribute('data-convert')) return;
      let strings;
      try {
        strings = JSON.parse(this.querySelector('[data-shipping-strings]')?.textContent || 'null');
      } catch {
        return;
      }
      if (!strings) return;
      const rate = Number(window.Shopify?.currency?.rate) || 1;
      // up to a whole unit, so the remaining amount reads "HK$600", not "HK$599.92"
      const threshold = Math.ceil((Number(this.dataset.threshold) * rate) / 100) * 100;
      const total = Number(this.dataset.total);
      if (!threshold) return;
      const remaining = threshold - total;
      const percent = Math.min(100, Math.floor((total * 100) / threshold));
      let amount;
      try {
        // like money_without_trailing_zeros: "HK$160", "HK$12.50"
        amount = new Intl.NumberFormat(document.documentElement.lang || undefined, {
          style: 'currency',
          currency: this.dataset.currency,
          ...(remaining % 100 === 0 ? { minimumFractionDigits: 0, maximumFractionDigits: 0 } : {}),
        }).format(remaining / 100);
      } catch {
        return;
      }
      this.querySelector('[data-shipping-text]').textContent =
        remaining > 0 ? strings.remaining.replace('[amount]', amount) : strings.reached;
      const track = this.querySelector('[role="progressbar"]');
      track.setAttribute('aria-valuenow', String(percent));
      track.querySelector('.shipping-progress__fill').style.inlineSize = `${percent}%`;
      if (remaining <= 0) {
        const status = this.closest('[data-cart-summary]')?.querySelector('[data-shipping-status]');
        // the drawer's compact note carries its own sentence (data-free)
        if (status) status.textContent = status.dataset.free || strings.free;
      }
    }
  }

  if (!customElements.get('cart-shipping-progress')) customElements.define('cart-shipping-progress', CartShippingProgress);

  /* ---------- snippets/cart-summary (defined here: a snippet's script only loads when it renders at page load) ---------- */

  /**
   * Final-sale acknowledgement (only when Theme settings require it): Checkout and the
   * express buttons stay disabled until the box is ticked. Without JavaScript the
   * checkbox is `required`, so the checkout form still will not submit unticked.
   * The tick survives the section being re-rendered after a quantity change.
   */
  class CartSummary extends HTMLElement {
    static acknowledged = false;

    connectedCallback() {
      this.ack = this.querySelector('[data-final-sale-ack]');
      if (this.ack) {
        this.ack.checked = CartSummary.acknowledged;
        this.ack.addEventListener('change', this.#onChange);
      }
      this.sync();
    }

    disconnectedCallback() {
      this.ack?.removeEventListener('change', this.#onChange);
    }

    #onChange = () => {
      CartSummary.acknowledged = this.ack.checked;
      this.sync();
    };

    sync() {
      const blocked = Boolean(this.ack && !this.ack.checked);
      const checkout = this.querySelector('[data-checkout]');
      if (checkout) checkout.disabled = blocked;
      const express = this.closest('cart-lines')?.querySelector('[data-cart-express]');
      if (express) express.inert = blocked;
    }
  }

  if (!customElements.get('cart-summary')) customElements.define('cart-summary', CartSummary);

  /* ---------- snippets/cart-gift (defined here: a snippet's script only loads when it renders at page load) ---------- */

  /**
   * Saves the gift flag, gift message (and order note on the cart page) as the shopper types.
   * A quantity change re-renders the section from the server while a save may still be
   * waiting: the unsaved values are kept per drawer/page and put back into the new fields,
   * and the waiting save is sent at once instead of being dropped.
   */
  class CartGift extends HTMLElement {
    /** open/closed per drawer or page, kept across section re-renders */
    static openState = new Map();
    /** values typed but not yet confirmed saved, per drawer or page */
    static drafts = new Map();

    connectedCallback() {
      this.details = this.querySelector('details');
      this.flag = this.querySelector('[data-gift-flag]');
      this.message = this.querySelector('[data-gift-message]');
      this.note = this.querySelector('[data-gift-note]');
      this.counter = this.querySelector('[data-gift-counter]');
      this.status = this.querySelector('[data-gift-status]');
      try {
        this.strings = JSON.parse(this.querySelector('[data-gift-strings]')?.textContent || '{}');
      } catch {
        this.strings = {};
      }
      if (CartGift.openState.get(this.dataset.id)) this.details.open = true;
      const draft = CartGift.drafts.get(this.dataset.id);
      if (draft) {
        this.flag.checked = draft.flag;
        this.message.value = draft.message;
        if (this.note && draft.note !== undefined) this.note.value = draft.note;
        this.#count();
      }
      this.details.addEventListener('toggle', this.#onToggle);
      this.addEventListener('input', this.#onEdit);
      this.addEventListener('change', this.#onEdit);
    }

    disconnectedCallback() {
      this.details.removeEventListener('toggle', this.#onToggle);
      this.removeEventListener('input', this.#onEdit);
      this.removeEventListener('change', this.#onEdit);
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
        this.save();
      }
    }

    #onToggle = () => {
      CartGift.openState.set(this.dataset.id, this.details.open);
    };

    #values() {
      return { flag: this.flag.checked, message: this.message.value, note: this.note?.value };
    }

    #count() {
      this.counter.textContent = this.counter.dataset.template.replace('[count]', this.message.value.length);
    }

    #onEdit = () => {
      this.#count();
      this.status.textContent = '';
      CartGift.drafts.set(this.dataset.id, this.#values());
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.timer = null;
        this.save();
      }, 400);
    };

    async save() {
      const values = this.#values();
      const body = { attributes: { Gift: values.flag ? 'Yes' : '', 'Gift message': values.message } };
      if (this.note) body.note = values.note;
      try {
        const response = await fetch(`${window.Shopify?.routes?.root ?? '/'}cart/update.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body),
        });
        if (!response.ok) throw new Error(String(response.status));
        const draft = CartGift.drafts.get(this.dataset.id);
        if (draft && draft.flag === values.flag && draft.message === values.message && draft.note === values.note) {
          CartGift.drafts.delete(this.dataset.id);
        }
        // the fields on screen may be a re-rendered copy: report on whichever is connected
        const status = this.isConnected ? this.status : document.querySelector(`cart-gift[data-id="${this.dataset.id}"] [data-gift-status]`);
        if (status) status.textContent = this.strings.saved ?? '';
      } catch {
        const status = this.isConnected ? this.status : document.querySelector(`cart-gift[data-id="${this.dataset.id}"] [data-gift-status]`);
        if (status) status.textContent = this.strings.error ?? '';
      }
    }
  }

  if (!customElements.get('cart-gift')) customElements.define('cart-gift', CartGift);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  /** Submits the filter/sort form as soon as a control changes. */
  class FacetForm extends HTMLElement {
    #timer = null;

    connectedCallback() {
      this.form = this.querySelector('form');
      this.form?.addEventListener('change', this.#onChange);
      this.#restoreFocus();
    }

    /* the page reloads on every change: put focus back on the control the shopper used */
    #restoreFocus() {
      let key = null;
      try {
        key = sessionStorage.getItem('facet-focus');
        sessionStorage.removeItem('facet-focus');
      } catch {}
      if (!key || !this.form) return;
      const control = [...this.form.elements].find((el) => `${el.name}|${el.value}` === key || el.name === key);
      control?.focus();
    }

    disconnectedCallback() {
      this.form?.removeEventListener('change', this.#onChange);
      clearTimeout(this.#timer);
    }

    #onChange = (event) => {
      const delay = event.target.type === 'number' ? 600 : 0;
      clearTimeout(this.#timer);
      this.#timer = setTimeout(() => this.#submit(), delay);
    };

    #submit() {
      const active = document.activeElement;
      if (active && this.form.contains(active) && active.name) {
        const key = active.type === 'checkbox' ? `${active.name}|${active.value}` : active.name;
        try {
          sessionStorage.setItem('facet-focus', key);
        } catch {}
      }
      const params = new URLSearchParams();
      for (const [key, value] of new FormData(this.form)) {
        if (value !== '') params.append(key, value);
      }
      const url = new URL(this.form.action, window.location.origin);
      url.search = params.toString();
      window.location.assign(url);
    }
  }

  if (!customElements.get('facet-form')) customElements.define('facet-form', FacetForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  /**
   * Closes open header menus on Escape and on clicks outside them, and opens the search overlay
   * from [data-search-open] links (the link's href to /search is the no-JS fallback).
   */
  class HeaderBar extends HTMLElement {
    #overlay = null;
    #trigger = null;

    #onKeydown = (event) => {
      if (event.key !== 'Escape') return;
      if (this.#isSearchOpen()) {
        this.closeSearch({ returnFocus: true });
        return;
      }
      this.#closeAll();
    };

    #onClick = (event) => {
      for (const details of this.querySelectorAll('details[open]')) {
        if (!details.contains(event.target)) details.open = false;
      }
      if (
        this.#isSearchOpen() &&
        !this.#overlay.contains(event.target) &&
        !event.target.closest?.('[data-search-open]')
      ) {
        this.closeSearch();
      }
    };

    #onHeaderClick = (event) => {
      const trigger = event.target.closest('[data-search-open]');
      if (trigger && this.#overlay) {
        event.preventDefault();
        if (this.#isSearchOpen()) this.closeSearch({ returnFocus: true });
        else this.openSearch(trigger);
        return;
      }
      if (event.target.closest('[data-search-close]')) this.closeSearch({ returnFocus: true });
    };

    /* focus that leaves the overlay for the page closes it; a tap on its own blank space does not */
    #onFocusout = (event) => {
      const next = event.relatedTarget;
      if (!next || this.#overlay.contains(next) || next.closest('[data-search-open]')) return;
      this.closeSearch();
    };

    #onToggle = (event) => {
      if (!event.target.matches('.menu-drawer') || !event.target.open) return;
      const bottom = this.getBoundingClientRect().bottom;
      event.target.style.setProperty('--drawer-top', `${Math.max(0, bottom)}px`);
    };

    connectedCallback() {
      this.#overlay = this.querySelector('#SearchOverlay');
      for (const trigger of this.querySelectorAll('[data-search-open]')) {
        trigger.setAttribute('aria-controls', 'SearchOverlay');
        trigger.setAttribute('aria-expanded', 'false');
      }
      document.addEventListener('keydown', this.#onKeydown);
      document.addEventListener('click', this.#onClick);
      this.addEventListener('click', this.#onHeaderClick);
      this.#overlay?.addEventListener('focusout', this.#onFocusout);
      // toggle does not bubble; listen in the capture phase
      this.addEventListener('toggle', this.#onToggle, true);
    }

    disconnectedCallback() {
      document.removeEventListener('keydown', this.#onKeydown);
      document.removeEventListener('click', this.#onClick);
    }

    openSearch(trigger) {
      if (!this.#overlay) return;
      for (const details of this.querySelectorAll('details[open]')) details.open = false;
      this.#trigger = trigger;
      const bottom = this.getBoundingClientRect().bottom;
      this.#overlay.style.setProperty('--search-top', `${Math.max(0, bottom)}px`);
      this.#overlay.hidden = false;
      for (const link of this.querySelectorAll('[data-search-open]')) link.setAttribute('aria-expanded', 'true');
      this.#overlay.querySelector('predictive-search')?.sync();
      this.#overlay.querySelector('input[type="search"]')?.focus();
    }

    closeSearch({ returnFocus = false } = {}) {
      if (!this.#isSearchOpen()) return;
      this.#overlay.hidden = true;
      for (const link of this.querySelectorAll('[data-search-open]')) link.setAttribute('aria-expanded', 'false');
      this.#overlay.querySelector('predictive-search')?.sync();
      if (returnFocus) this.#trigger?.focus();
    }

    #isSearchOpen() {
      return Boolean(this.#overlay && !this.#overlay.hidden);
    }

    #closeAll() {
      for (const details of this.querySelectorAll('details[open]')) {
        details.open = false;
        details.querySelector('summary')?.focus();
      }
    }
  }

  if (!customElements.get('header-bar')) customElements.define('header-bar', HeaderBar);

  /**
   * Combobox over a search input: fetches sections/predictive-search.liquid as the shopper types
   * and puts its listbox options under the field. Arrow keys move aria-activedescendant, Enter
   * follows the active option, otherwise the form submits to /search as it would without JS.
   * [data-initial]: the listbox's server-rendered content (popular links) shows while the field is short.
   */
  class PredictiveSearch extends HTMLElement {
    #input = null;
    #results = null;
    #initial = '';
    #controller = null;
    #timer = 0;

    #onInput = () => {
      clearTimeout(this.#timer);
      const term = this.#term();
      if (term.length < 2) {
        this.#controller?.abort();
        this.#results.removeAttribute('aria-busy');
        this.#results.innerHTML = this.#initial;
        this.#prefixIds();
        this.sync();
        return;
      }
      this.#timer = setTimeout(() => this.#search(term), 250);
    };

    #onKeydown = (event) => {
      if (event.isComposing) return;
      const options = this.#options();
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        if (!options.length || this.#results.hidden) return;
        event.preventDefault();
        const index = options.findIndex((option) => option.getAttribute('aria-selected') === 'true');
        let next;
        if (event.key === 'ArrowDown') next = index + 1 >= options.length ? 0 : index + 1;
        else next = index <= 0 ? options.length - 1 : index - 1;
        this.#activate(options[next]);
      } else if (event.key === 'Enter') {
        const active = options.find((option) => option.getAttribute('aria-selected') === 'true');
        if (!active) return;
        event.preventDefault();
        active.click();
      }
    };

    connectedCallback() {
      this.#input = this.querySelector('input[type="search"]');
      this.#results = this.querySelector('[role="listbox"]');
      if (!this.#input || !this.#results) return;
      this.#initial = this.hasAttribute('data-initial') ? this.#results.innerHTML : '';
      this.#input.addEventListener('input', this.#onInput);
      this.#input.addEventListener('keydown', this.#onKeydown);
      this.#prefixIds();
      this.sync();
    }

    disconnectedCallback() {
      clearTimeout(this.#timer);
      this.#controller?.abort();
    }

    /** Shows or hides the listbox and keeps aria-expanded / aria-activedescendant true to it. */
    sync() {
      if (!this.#input) return;
      const hasContent = this.#results.innerHTML.trim() !== '';
      this.#results.hidden = !hasContent;
      const visible = hasContent && this.#input.offsetParent !== null;
      this.#input.setAttribute('aria-expanded', String(visible && this.#options().length > 0));
      this.#activate(null);
    }

    #term() {
      return this.#input.value.trim();
    }

    #options() {
      return [...this.#results.querySelectorAll('[role="option"]')];
    }

    #activate(option) {
      for (const other of this.#options()) other.setAttribute('aria-selected', 'false');
      if (!option) {
        this.#input.removeAttribute('aria-activedescendant');
        return;
      }
      option.setAttribute('aria-selected', 'true');
      this.#input.setAttribute('aria-activedescendant', option.id);
      option.scrollIntoView({ block: 'nearest' });
    }

    /* two instances share one results template: give every id this listbox's prefix */
    #prefixIds() {
      const prefix = `${this.#results.id}-`;
      for (const element of this.#results.querySelectorAll('[id]')) {
        if (!element.id.startsWith(prefix)) element.id = prefix + element.id;
      }
      for (const element of this.#results.querySelectorAll('[aria-labelledby]')) {
        const ids = element.getAttribute('aria-labelledby').split(' ');
        element.setAttribute(
          'aria-labelledby',
          ids.map((id) => (id.startsWith(prefix) ? id : prefix + id)).join(' ')
        );
      }
    }

    async #search(term) {
      this.#controller?.abort();
      this.#controller = new AbortController();
      const params = [
        `q=${encodeURIComponent(term)}`,
        'resources[type]=query,product,collection,page,article',
        'resources[limit]=4',
        'resources[options][unavailable_products]=last',
        'section_id=predictive-search',
      ].join('&');
      this.#results.setAttribute('aria-busy', 'true');
      try {
        const response = await fetch(`${this.dataset.url}?${params}`, { signal: this.#controller.signal });
        if (!response.ok) throw new Error(`${response.status}`);
        const html = await response.text();
        if (term !== this.#term()) return;
        const fresh = new DOMParser()
          .parseFromString(html, 'text/html')
          .getElementById('predictive-search-results');
        if (!fresh) return;
        this.#results.innerHTML = fresh.innerHTML;
        this.#prefixIds();
        this.sync();
        const message =
          fresh.dataset.announce || fresh.querySelector('.predictive-search__empty')?.textContent.trim();
        if (message) window.announce?.(message);
      } catch (error) {
        // aborted by a newer keystroke, or offline: the form still submits to /search
        if (error.name !== 'AbortError') this.#results.removeAttribute('aria-busy');
        return;
      }
      this.#results.removeAttribute('aria-busy');
    }
  }

  if (!customElements.get('predictive-search')) customElements.define('predictive-search', PredictiveSearch);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["help-page"]) return;
  try {
    
  /**
   * Customer-care page. Everything here is an enhancement of server-rendered HTML:
   * - phones: scroll the current page's link into view in the side-nav row;
   * - tables: end-align columns whose body cells are all figures;
   * - FAQ (data-accordions): each h3 and the answer after it become a native <details>,
   *   and a #hash naming a question opens it.
   */
  class HelpPage extends HTMLElement {
    connectedCallback() {
      this.body = this.querySelector('.help-page__body');
      this.revealCurrentLink();
      this.alignNumericColumns();

      if (this.hasAttribute('data-accordions')) {
        this.buildAccordions();
        this.onHashChange = () => this.openFromHash(true);
        window.addEventListener('hashchange', this.onHashChange);
        this.openFromHash(true);
      }
    }

    disconnectedCallback() {
      if (this.onHashChange) window.removeEventListener('hashchange', this.onHashChange);
    }

    revealCurrentLink() {
      const nav = this.querySelector('.help-page__nav');
      const current = nav?.querySelector('[aria-current="page"]');
      if (!current || nav.scrollWidth <= nav.clientWidth + 1) return;
      const item = current.closest('li');
      nav.scrollLeft = item.offsetLeft - (nav.clientWidth - item.offsetWidth) / 2;
    }

    alignNumericColumns() {
      const figure = /^[\d\s.,–-]+(\s?(mm|cm|in|g))?$/i;
      for (const table of this.body.querySelectorAll('table')) {
        const rows = [...table.querySelectorAll('tbody tr')];
        if (!rows.length) continue;
        const columns = Math.max(...rows.map((row) => row.cells.length));
        for (let i = 0; i < columns; i++) {
          const numeric = rows.every((row) => row.cells[i] && figure.test(row.cells[i].textContent.trim()));
          if (!numeric) continue;
          for (const row of table.rows) row.cells[i]?.classList.add('is-numeric');
        }
      }
    }

    buildAccordions() {
      const icon = this.querySelector('template.help-page__icon');
      const used = new Set();
      for (const heading of [...this.body.children].filter((el) => el.tagName === 'H3')) {
        if (!heading.id) heading.id = this.slug(heading.textContent, used);
        used.add(heading.id);

        const details = document.createElement('details');
        details.className = 'accordion';
        const summary = document.createElement('summary');
        summary.className = 'accordion__summary';
        const content = document.createElement('div');
        content.className = 'accordion__content';

        // the answer: every node after the question up to the next h2/h3 (text and comments included)
        let node = heading.nextSibling;
        while (node && !(node.nodeType === Node.ELEMENT_NODE && /^H[23]$/.test(node.tagName))) {
          const next = node.nextSibling;
          content.append(node);
          node = next;
        }

        heading.replaceWith(details);
        summary.append(heading);
        if (icon) summary.append(icon.content.cloneNode(true));
        details.append(summary, content);
      }
    }

    slug(text, used) {
      const base =
        text
          .trim()
          .toLowerCase()
          .normalize('NFKD')
          .replace(/[^\p{L}\p{N}]+/gu, '-')
          .replace(/^-+|-+$/g, '') || 'question';
      let id = base;
      for (let n = 2; used.has(id) || document.getElementById(id); n++) id = `${base}-${n}`;
      return id;
    }

    openFromHash(scroll) {
      let id;
      try {
        id = decodeURIComponent(location.hash.slice(1));
      } catch {
        return;
      }
      if (!id) return;
      const target = document.getElementById(id);
      const details = target?.closest('details.accordion');
      if (!details || !this.body.contains(details)) return;
      details.open = true;
      if (scroll) target.scrollIntoView({ block: 'start' });
    }
  }

  if (!customElements.get('help-page')) customElements.define('help-page', HelpPage);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slideshow"] && !Shopify.designMode) return;
  try {
    
  class HeroSlideshow extends HTMLElement {
    #index = 0;
    #timer = null;
    #paused = false;

    connectedCallback() {
      this.slides = [...this.querySelectorAll('[data-slide]')];
      this.dots = [...this.querySelectorAll('[data-dot]')];
      if (this.slides.length < 2) return;
      this.dots.forEach((dot) => dot.addEventListener('click', () => this.show(Number(dot.dataset.dot), true)));

      const pause = () => { this.#paused = true; this.#stop(); };
      const resume = () => { this.#paused = false; this.#start(); };
      this.addEventListener('pointerenter', pause);
      this.addEventListener('pointerleave', resume);
      this.addEventListener('focusin', pause);
      this.addEventListener('focusout', (event) => { if (!this.contains(event.relatedTarget)) resume(); });
      document.addEventListener('visibilitychange', () => (document.hidden ? this.#stop() : this.#start()));

      // swipe on touch screens
      let startX = null;
      this.addEventListener('touchstart', (event) => { startX = event.touches[0].clientX; }, { passive: true });
      this.addEventListener('touchend', (event) => {
        if (startX === null) return;
        const dx = event.changedTouches[0].clientX - startX;
        startX = null;
        if (Math.abs(dx) > 40) this.show(this.#index + (dx < 0 ? 1 : -1), true);
      });

      // theme editor: show the slide being edited, and stay on it
      this.addEventListener('shopify:block:select', (event) => {
        const i = this.slides.indexOf(event.target.closest('[data-slide]'));
        if (i >= 0) { this.#stop(); this.show(i, false); this.#paused = true; }
      });
      this.addEventListener('shopify:block:deselect', () => { this.#paused = false; this.#start(); });

      this.#start();
    }

    disconnectedCallback() {
      this.#stop();
    }

    get #delay() {
      const ms = Number(this.dataset.autoplay);
      if (!ms || matchMedia('(prefers-reduced-motion: reduce)').matches) return 0;
      return ms;
    }

    #start() {
      this.#stop();
      if (this.#paused || document.hidden || !this.#delay) return;
      this.#timer = setInterval(() => this.show(this.#index + 1, false), this.#delay);
    }

    #stop() {
      clearInterval(this.#timer);
      this.#timer = null;
    }

    show(index, byUser) {
      const n = this.slides.length;
      this.#index = ((index % n) + n) % n;
      this.slides.forEach((slide, i) => {
        const on = i === this.#index;
        slide.toggleAttribute('data-active', on);
        slide.toggleAttribute('inert', !on);
        if (on) slide.removeAttribute('aria-hidden');
        else slide.setAttribute('aria-hidden', 'true');
      });
      this.dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === this.#index)));
      if (byUser) this.#start();  // a chosen slide gets its full time before moving on
    }
  }

  if (!customElements.get('hero-slideshow')) customElements.define('hero-slideshow', HeroSlideshow);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lookbook"] && !Shopify.designMode) return;
  try {
    
  /*
   * Lookbook product cards are popovers, which sit in the top layer, fixed to the screen.
   * Place each one at its dot while open: centred under the dot (above it when there is no
   * room below), clamped inside the screen, following the dot as the page scrolls, and closed
   * once the dot has scrolled out of view.
   */
  (() => {
    const GAP = 8;
    const EDGE = 12;

    function place(card, spot) {
      const dot = spot.getBoundingClientRect();
      const box = card.getBoundingClientRect();
      if (dot.bottom < 0 || dot.top > innerHeight) {
        card.hidePopover();
        return;
      }
      let left = dot.left + dot.width / 2 - box.width / 2;
      left = Math.min(Math.max(left, EDGE), innerWidth - box.width - EDGE);
      let top = dot.bottom + GAP;
      if (top + box.height > innerHeight - EDGE) top = Math.max(EDGE, dot.top - GAP - box.height);
      card.style.left = `${Math.round(left)}px`;
      card.style.top = `${Math.round(top)}px`;
      card.dataset.placed = '';
    }

    document.addEventListener(
      'toggle',
      (event) => {
        const card = event.target;
        if (!(card instanceof HTMLElement) || !card.matches('.lookbook__card')) return;
        const spot = document.querySelector(`[popovertarget="${card.id}"]`);
        if (!spot) return;
        if (event.newState === 'open') {
          place(card, spot);
          const follow = () => requestAnimationFrame(() => card.matches(':popover-open') && place(card, spot));
          card._follow = follow;
          addEventListener('scroll', follow, { passive: true });
          addEventListener('resize', follow);
        } else {
          delete card.dataset.placed;
          removeEventListener('scroll', card._follow);
          removeEventListener('resize', card._follow);
        }
      },
      true
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-recommendations')) {
    customElements.define(
      'product-recommendations',
      class ProductRecommendations extends HTMLElement {
        connectedCallback() {
          if (!this.dataset.url || this.querySelector('.product-grid')) return;
          this.observer = new IntersectionObserver(
            (entries) => {
              if (!entries.some((entry) => entry.isIntersecting)) return;
              this.observer.disconnect();
              this.load();
            },
            // 400px ahead of the viewport; the huge top margin also catches a jump past it (End key, anchor)
            { rootMargin: '100000px 0px 400px 0px' }
          );
          this.observer.observe(this);
        }

        disconnectedCallback() {
          this.observer?.disconnect();
        }

        async load() {
          let html = '';
          try {
            const response = await fetch(this.dataset.url);
            if (response.ok) {
              const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
              const fetched = doc.querySelector('product-recommendations');
              if (fetched?.querySelector('.product-grid li')) html = fetched.innerHTML;
            }
          } catch (error) {
            // offline or blocked: fall through to the collection fallback, or stay hidden
          }
          if (!html) {
            const template = this.querySelector('template[data-fallback]');
            if (template?.content.querySelector('.product-grid li')) html = template.innerHTML;
          }
          if (html) this.innerHTML = html;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  /**
   * Product page: option picker -> variant, quantity steppers, add to bag
   * through the cart drawer, gallery counter on the mobile swipe strip,
   * the image viewer, and the phone buy bar.
   */
  class ProductPage extends HTMLElement {
    #controller = null;
    #stickyState = { past: false, footer: false };
    #phone = window.matchMedia('(max-width: 989px)');

    connectedCallback() {
      this.variants = JSON.parse(this.querySelector('[data-variants]')?.textContent || '[]');
      this.form = this.querySelector('[data-product-form]');
      this.addEventListener('change', this.#onChange);
      this.addEventListener('click', this.#onClick);
      this.form?.addEventListener('submit', this.#onSubmit);
      this.#watchGallery();
      this.#setupToggleAll();
      this.#setupStickyBar();
      this.#rememberView();
      this.#confirmRestock();
    }

    /**
     * The sign-up posts to /contact#RestockForm and Shopify sends the visitor back without
     * the ?variant= they chose, so the page can reopen on an in-stock variant with no
     * sign-up in it. The thank-you still belongs here.
     */
    async #confirmRestock() {
      const params = new URLSearchParams(window.location.search);
      const restock = this.querySelector('[data-restock]');
      if (!restock || params.get('customer_posted') !== 'true') return;
      if (window.location.hash !== '#RestockForm') {
        // Shopify marks every customer form as posted: a newsletter sign-up is not a thank-you here
        if (!restock.querySelector('.restock__success')) return;
        const url = new URL(this.dataset.url, window.location.origin);
        url.searchParams.set('variant', this.querySelector('[data-variant-id]')?.value ?? '');
        url.searchParams.set('section_id', this.dataset.section);
        try {
          const response = await fetch(url);
          const fresh = new DOMParser().parseFromString(await response.text(), 'text/html').querySelector('[data-restock]');
          if (fresh) this.querySelector('[data-restock]')?.replaceWith(fresh);
        } catch {
          // offline: the thank-you stays, the form comes back on the next visit
        }
        return;
      }
      if (restock.querySelector('.restock__success, .restock__error')) return;
      const note = document.createElement('p');
      note.className = 'restock__success';
      note.setAttribute('role', 'status');
      note.textContent = this.dataset.restockSuccess;
      restock.replaceChildren(note);
      restock.scrollIntoView({ block: 'center' });
    }

    /**
     * The phone buy bar: shown once the main buy block has scrolled up out of view,
     * hidden again while the footer is on screen, and never on desktop. Hidden means
     * aria-hidden and inert, so it is out of the tab order and the reading order.
     */
    #setupStickyBar() {
      const bar = this.querySelector('[data-sticky-bar]');
      const buy = this.querySelector('[data-buy]');
      if (!bar || !buy) return;
      const footer = document.querySelector('.site-footer, footer');
      // the buy block's viewport runs on far below the screen, so it only stops intersecting
      // once it has scrolled off the top (a jump from the footer to the top still reports)
      this.buyObserver = new IntersectionObserver(
        ([entry]) => {
          this.#stickyState.past = !entry.isIntersecting;
          this.#updateStickyBar();
        },
        { rootMargin: '0px 0px 100000px 0px' }
      );
      this.buyObserver.observe(buy);
      if (footer) {
        this.footerObserver = new IntersectionObserver(([entry]) => {
          this.#stickyState.footer = entry.isIntersecting;
          this.#updateStickyBar();
        });
        this.footerObserver.observe(footer);
      }
      this.#phone.addEventListener('change', this.#updateStickyBar);
    }

    #updateStickyBar = () => {
      const bar = this.querySelector('[data-sticky-bar]');
      if (!bar) return;
      const show = this.#phone.matches && this.#stickyState.past && !this.#stickyState.footer;
      if (show) {
        bar.removeAttribute('aria-hidden');
        bar.inert = false;
      } else {
        // keep focus off a control that is about to disappear
        if (bar.contains(document.activeElement)) this.querySelector('[data-add-button]')?.focus({ preventScroll: true });
        bar.setAttribute('aria-hidden', 'true');
        bar.inert = true;
      }
    };

    /** Remember this piece for "Recently viewed" (bag drawer, cart page): newest first, 12 at most, per visitor. */
    #rememberView() {
      if (window.Shopify?.designMode) return;
      const key = 'morrow:recent';
      const { handle, productId } = this.dataset;
      if (!handle) return;
      try {
        const list = JSON.parse(window.localStorage.getItem(key) || '[]');
        const others = (Array.isArray(list) ? list : []).filter((item) => item && item.handle !== handle);
        window.localStorage.setItem(key, JSON.stringify([{ id: productId, handle }, ...others].slice(0, 12)));
      } catch {
        // storage can be unavailable (private mode, blocked): recently viewed simply stays empty
      }
    }

    /** "Expand all" until every section is open, then "Collapse all"; follows single toggles too. */
    #setupToggleAll() {
      const button = this.querySelector('[data-toggle-all]');
      const sections = [...this.querySelectorAll('details.accordion')];
      if (!button || sections.length < 2) return;
      const update = () => {
        const allOpen = sections.every((details) => details.open);
        button.textContent = allOpen ? button.dataset.collapse : button.dataset.expand;
        button.setAttribute('aria-expanded', String(allOpen));
      };
      button.addEventListener('click', () => {
        const open = !sections.every((details) => details.open);
        for (const details of sections) details.open = open;
        update();
      });
      for (const details of sections) details.addEventListener('toggle', update);
      button.closest('.product__accordion-bar').hidden = false;
      update();
    }

    disconnectedCallback() {
      this.#controller?.abort();
      this.observer?.disconnect();
      this.buyObserver?.disconnect();
      this.footerObserver?.disconnect();
      this.#phone.removeEventListener('change', this.#updateStickyBar);
    }

    #onClick = (event) => {
      const zoom = event.target.closest('[data-lightbox-open]');
      if (zoom) {
        this.querySelector('product-lightbox')?.open(zoom.dataset.lightboxOpen, zoom);
        return;
      }
      if (event.target.closest('[data-restock-jump]')) {
        this.#jumpToRestock();
        return;
      }
      const step = event.target.closest('[data-step]');
      if (!step) return;
      const input = this.querySelector('.quantity__input');
      input.value = Math.max(1, Number(input.value || 1) + Number(step.dataset.step));
    };

    #onChange = (event) => {
      if (!event.target.matches('[data-option-index]')) return;
      const selected = [...this.querySelectorAll('[data-option-index]:checked')].map((input) => input.value);
      const label = this.querySelector(`[data-option-selected="${event.target.dataset.optionIndex}"]`);
      if (label) label.textContent = event.target.value;
      const variant = this.variants.find((candidate) => candidate.options.every((value, index) => value === selected[index]));
      this.#setVariant(variant);
    };

    /** Sold out: the bar's button brings the email sign-up into view and puts the cursor in it. */
    #jumpToRestock() {
      const restock = this.querySelector('[data-restock]');
      if (!restock) return;
      const smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      restock.scrollIntoView({ block: 'center', behavior: smooth ? 'smooth' : 'auto' });
      restock.querySelector('input[type="email"]')?.focus({ preventScroll: true });
    }

    async #setVariant(variant) {
      const button = this.querySelector('[data-add-button]');
      if (!variant) {
        const label = window.themeStrings?.unavailable ?? 'Unavailable';
        for (const control of [button, this.querySelector('[data-sticky-button]')]) {
          if (!control) continue;
          control.disabled = true;
          control.textContent = label;
          control.removeAttribute('aria-label');
        }
        // no such piece: the last variant's stock line, dispatch date and sign-up (tagged with its id) would mislead
        for (const selector of ['[data-stock]', '[data-restock]', '[data-delivery]']) {
          const node = this.querySelector(selector);
          if (node) node.hidden = true;
        }
        return;
      }
      this.querySelector('[data-variant-id]').value = variant.id;
      const url = new URL(this.dataset.url, window.location.origin);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);

      this.#controller?.abort();
      this.#controller = new AbortController();
      url.searchParams.set('section_id', this.dataset.section);
      try {
        const response = await fetch(url, { signal: this.#controller.signal });
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const swapped = [
          '[data-price]',
          '[data-add-button]',
          '[data-stock]',
          '[data-delivery]',
          '[data-restock]',
          '[data-sticky-title]',
          '[data-sticky-price]',
          '[data-sticky-button]',
        ];
        for (const selector of swapped) {
          const fresh = html.querySelector(selector);
          const current = this.querySelector(selector);
          if (fresh && current) current.replaceWith(fresh);
        }
        this.#showMedia(variant.featured_media?.id);
        const price = this.querySelector('[data-price] .price')?.textContent.trim().replace(/\s+/g, ' ');
        window.announce?.(`${variant.title}, ${price}`);
      } catch (error) {
        if (error.name !== 'AbortError') throw error;
      }
    }

    /**
     * Bring the variant's own picture forward. Phones (a swipe gallery): slide the
     * gallery sideways to it, never moving the page. Desktop (stacked pictures):
     * move it to the top of the stack, so the page does not jump.
     * @param {number} [mediaId]
     */
    #showMedia(mediaId) {
      if (!mediaId) return;
      const list = this.querySelector('.product__media-list');
      const item = this.querySelector(`#Media-${this.dataset.section}-${mediaId}`);
      if (!list || !item) return;
      const stacked = getComputedStyle(list).gridAutoFlow.startsWith('row');
      if (stacked) {
        if (list.firstElementChild === item) return;
        list.prepend(item);
        item.querySelector('img')?.setAttribute('loading', 'eager');
        // the viewer follows the gallery order, and the zoom buttons say where they are in it
        const viewerItem = this.querySelector(`[data-media-id="${mediaId}"]`);
        viewerItem?.parentElement.prepend(viewerItem);
        const template = list.dataset.zoomLabel;
        if (template) {
          [...list.querySelectorAll('[data-lightbox-open]')].forEach((zoom, index) => {
            zoom.setAttribute('aria-label', template.replace('[index]', index + 1));
          });
        }
        return;
      }
      const smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      list.scrollTo({ left: item.offsetLeft - list.offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
    }

    #onSubmit = async (event) => {
      const drawer = document.querySelector('cart-drawer');
      if (!drawer) return;
      event.preventDefault();
      // the main button and the phone bar's button share one busy state
      const buttons = [this.querySelector('[data-add-button]'), this.querySelector('[data-sticky-button][form]')].filter(Boolean);
      const error = this.querySelector('[data-error]');
      if (buttons.some((button) => button.getAttribute('aria-busy') === 'true')) return;
      const labels = buttons.map((button) => button.textContent);
      for (const button of buttons) {
        button.setAttribute('aria-busy', 'true');
        button.textContent = window.themeStrings?.adding ?? button.textContent;
      }
      error.hidden = true;
      try {
        await drawer.add(new FormData(this.form));
      } catch (failure) {
        error.textContent = failure.message;
        error.hidden = false;
        // a failure from the phone bar is shown next to the main button: bring it into view
        if (event.submitter?.matches('[data-sticky-button]')) error.scrollIntoView({ block: 'center' });
      } finally {
        buttons.forEach((button, index) => {
          button.removeAttribute('aria-busy');
          button.textContent = labels[index];
        });
      }
    };

    #watchGallery() {
      const counter = this.querySelector('[data-media-index]');
      if (!counter) return;
      const items = [...this.querySelectorAll('.product__media-item')];
      this.observer = new IntersectionObserver(
        (entries) => {
          for (const entry of entries) {
            if (entry.isIntersecting) counter.textContent = items.indexOf(entry.target) + 1;
          }
        },
        { root: this.querySelector('.product__media-list'), threshold: 0.6 }
      );
      for (const item of items) this.observer.observe(item);
    }
  }

  if (!customElements.get('product-page')) customElements.define('product-page', ProductPage);

  } catch(e) { console.error(e); }
})();
})();
